import React from "react";

interface IOTCommunicationModalModalProps {
    isOpen: boolean;
    message: React.ReactNode;
    setIsValveModalOpen: (isOpen: boolean) => void;
    handleOpenValveClick?: () => Promise<void>;
}

const IOTCommunicationModal: React.FC<IOTCommunicationModalModalProps> = ({ isOpen, message, setIsValveModalOpen, handleOpenValveClick }) => {
    if (!isOpen) return null; // Don't render if not open

    return (
        <div
            className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 p-4"
            onClick={() => setIsValveModalOpen(false)} // Close on background click
        >
            <div
                className="bg-darkcolor-600 p-8 rounded-lg shadow-lg w-full sm:max-w-sm md:max-w-md lg:max-w-md"
                onClick={(e) => e.stopPropagation()} // Prevent closing when clicking inside
                style={{ width: "80%" }}
            >
                <h2
                    className="text-sm font-normal text-white text-left leading-relaxed"
                    style={{ whiteSpace: "pre-line" }}
                >
                    {message}
                </h2>


                <div className="flex justify-center gap-4 mt-6">
                    <button
                        onClick={async () => {
                            setIsValveModalOpen(false);
                        }}
                        style={{ float: "right", backgroundColor: "var(--Primary-Indigo-700, #005F7C)" }}
                        className="px-6 py-3 bg-primary-700 text-white rounded-md hover:bg-primary-800 transition-all"
                    >
                        OK
                    </button>
                </div>
            </div>
        </div>
    );
};

export default IOTCommunicationModal;
